<div class="substatus-container" *ngIf="!isLoadingLabels && !isLoadingStatus">
	<div class="search" *ngIf="statusSubstatusInterface.id == undefined">
		<cpi-msp-table
			[header]="searchHeader"
			[body]="statusSubstatusList"
			[searchable]="true"
			[height]="'55dvh'"
			[itemPadding]="'1%'"
			[labels]="labels"
			[insideSort]="true"
			(getSelectedItem)="openForm($event[0])">
		</cpi-msp-table>

		<div class="button-container">
			<div class="button" (click)="clearInputs(true)">{{ labels.lbl_geral_novo }}</div>
		</div>
	</div>

	<ng-container *ngIf="statusSubstatusInterface.id != undefined">
		<div class="header-wrap">
			<span class="tab selected">{{ labels.lbl_geral_substatus }}</span>
		</div>
		<div class="body-wrap">
			<div class="search-container">
				<!---<div class="dotted-input-container">
          <span>{{ labels.lbl_geral_pesquisar }}</span>
          <input type="text" [value]="searchText" [placeholder]="labels.lbl_geral_pesquisar" (input)="searchItems()"/>
        </div>

        <div class="table-container">
          <table>
            <thead>
              <tr>
                <th (click)="selectAll()">
                  <fa-icon [icon]="allSelected === true ? icons.faCheckSquare : icons.faSquare"></fa-icon>
                </th>
                <th>{{ labels.lbl_geral_substatus }}</th>
                <th>{{ labels.lbl_status }}</th>
                <th>{{ labels.lbl_bulletin_actions }}</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngIf="filteredItems.length > 0; else showAll">
                <tr class="select-bond" *ngFor="let item of filteredItems; let indexItem = index">
                  <td>
                    <fa-icon [icon]="item.isChecked === true ? icons.faCheckSquare : icons.faSquare" (click)="selectMultiple(item, indexItem)"></fa-icon>
                  </td>
                  <td>{{ item.substatus }}</td>
                  <td>{{ item.statusName }}</td>
                  <td>
                    <fa-icon [icon]="icons.faPencil" (click)="openForm(item)"></fa-icon>
                  </td>
                </tr>
              </ng-container>
              <ng-template #showAll>
                <tr class="select-bond" *ngFor="let item of statusSubstatusList; let indexItem = index">
                  <td>
                    <fa-icon [icon]="item.isChecked === true ? icons.faCheckSquare : icons.faSquare" (click)="selectMultiple(item, indexItem)"></fa-icon>
                  </td>
                  <td>{{ item.substatus }}</td>
                  <td>{{ item.statusName }}</td>
                  <td>
                    <fa-icon [icon]="icons.faPencil" (click)="openForm(item)"></fa-icon>
                  </td>
                </tr>
              </ng-template>
            </tbody>
          </table>
        </div>--->

				<div class="form-container">
					<div class="dotted-input-container">
						<span>{{ labels.lbl_status }}</span>
						<select id="type" name="type" [(ngModel)]="statusSubstatusInterface.statusId">
							<option [value]="''" selected>{{ labels.lbl_geral_selecione }}</option>
							<option *ngFor="let option of statusList" [value]="option.id">{{ option.status }}</option>
						</select>
					</div>

					<div class="dotted-input-container">
						<span>{{ labels.lbl_geral_substatus }}*</span>
						<input id="status" name="status" type="text" [(ngModel)]="statusSubstatusInterface.substatus" />
					</div>

					<div class="button-container">
						<div class="button" (click)="clearInputs(false)">{{ labels.lbl_geral_voltar }}</div>
						<div class="button" (click)="clearInputs(true)">{{ labels.lbl_geral_novo }}</div>
						<div class="button" (click)="deletedSelected($event)" #activateButton>
							{{ activateButton.classList.contains('double-click') ? labels.lbl_geral_confirmar : labels.lbl_geral_excluir }}
						</div>
						<div class="button" (click)="validateForm()">{{ labels.lbl_geral_salvar }}</div>
					</div>
				</div>
			</div>
		</div>
	</ng-container>
</div>

<cpi-dot-bounce-loading-effect class="mt-2 ml-2" *ngIf="isLoadingStatus" [color]="'var(--primary-color-1)'"></cpi-dot-bounce-loading-effect>
